<template>
  <div id="container" ref="mapRef" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <nyTit  pathUrl='/zhinengGG'/>
    <div class="content">
      <div class="left1">
        <div class="title"><span>气象监测数据</span></div>
         <div class="leftBox1">
           <div class="leftBox1_item" v-for="(item,index) in state.leftData1" :key="index">
             <div class="leftBox1_item_circle"><span>{{item.value}}</span></div>
             <div class="name">{{item.name}}<span>{{item.unit}}</span></div>
           </div>
         </div>
          <div class="leftBox2">
            <div class="leftBox2_item" v-for="(item,index) in state.leftData2">
              <span class="leftBox2_item_tit">{{item.title}}</span>
              <div class="leftBox2_item_bg"><span :style="{width:item.value/30*100+'%'}"></span></div>
              <span class="leftBox2_item_value">{{item.value}}天</span>
            </div>
          </div>

      </div>
      <div class="left2">
          <div class="left2Box1">
            <div class="title"><span>土壤数据监测</span></div>
            <div class="echartsBox">
                <leftLine :leftData3="state.leftData3" />
            </div>
          </div>
        <div class="left2Box2">
          <div class="title"><span>降水预测指数</span></div>
          <div class="echartsBox"><leftBar2 :leftData4="state.leftData4" /></div>
        </div>
      </div>

      <div class="center">
        <div class="centerBox1">
          <img src="../assets/img/gbzntyj/qixiang1/zx.png"/>
          <div v-for="(item,index) in state.centerVideo" :key="index" class="videoItem" @click="videoClick(index)">{{index+1}}</div>
        </div>
        <div class="centerBox2"><navItem /></div>
      </div>
      <div class="right">
        <div class="rightBox1">
          <div class="title">受灾害预警数据</div>
          <div class="rightBox1_content">
            <div class="rightBox1_left">
              <div class="rightBox1_left_item" v-for="(item,index) in state.rightData1" :key="index">
                <div class="rightBox1_left_item_border">
                  <img :src="item.icon" />
                  <h5>{{index+1}}</h5>
                </div>
                <h6>{{item.name}}</h6>
              </div>
            </div>
            <div class="rightBox1_right">
              <txtScroll>
                <div v-for="item in state.rightDataTxtList" :key="item.id" class="scroll_item">
                  <span class="tx">提醒</span>
                  <span class="tit">{{item.tit}}</span>
                  <span class="time">{{item.time}}</span>
                </div>
              </txtScroll>
            </div>
          </div>

        </div>
        <div class="rightBox2">
          <div class="title">天气预警数据</div>
          <div class="rightBox2_tit"><div class="rightBox2_tit_item" :class="{rightBox2_tit_item_cur:state.rightData2Cur==index}" v-for="(item,index) in state.rightData2" @click="clickWeather(index)">{{item.name}}</div></div>

          <div class="echartsBox"><rightLine :rightData2="state.rightData2[state.rightData2Cur].data" :rightData2Cur="state.rightData2Cur" v-if="state.showDiv" />></div>
        </div>

      </div>
    </div>
    
  </div>
   <div class="footer">本产品由来村网提供技术支持</div>
  <popBg :title="state.centerVideo[state.curVideoIndex].name" :popShow="state.popShow" @hiddlen="popHiddlen">
    <vue3VideoPlay id="video"  width="100%"  height="100%"  title="冰河世纪"  :src="state.centerVideo[state.curVideoIndex].options.src"  :type="state.centerVideo[state.curVideoIndex].options.type"  :autoPlay="true"/>
  </popBg>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
} from "vue";

import nyTit from '@/components/nyTit'
import navItem from '@/components/nyNav'

import leftBar2 from '@/components/QihouYj/leftBar2'
import leftLine from '@/components/QihouYj/leftLine'
import rightLine from '@/components/QihouYj/rightLine.vue'
import txtScroll from "@/components/xiaofeiChanpin/txtScroll.vue"
import popBg from "@/components/popBg.vue";
const router = useRouter();
const state = reactive({
  leftData1:[
    {name:"风速",value:10,unit:"m/s"},
    {name:"风向",value:'东南',unit:""},
    {name:"雨量",value:10,unit:"mm"},
    {name:"温度",value:'26',unit:""},
    {name:"湿度",value:10,unit:"%"},
    {name:"光照",value:'1258',unit:"Lux"},
  ],
  leftData2:[
    {title:"优",value:18},
    {title:"俍",value:12},
    {title:"轻度",value:8},
    {title:"中度",value:6},
    {title:"重度",value:3},
    {title:"严重",value:2}
  ],
  leftData4:[
    ["3/21", "3/22", "3/23", "3/24","3/25", "3/26", "3/27", "3/28"],
    [5.6, 8.9, 6, 5.8,5.6, 8.9, 6, 5.8]
  ],
  leftData3:[
    ["3/21", "3/22", "3/23", "3/24","3/25", "3/26", "3/27", "3/28"],
    [20, 28, 19, 26, 36, 35, 25,20],
    [ 86, 35, 25,20, 58, 19, 56, 86]
  ],
  centerVideo:[
    {name:"1号监控",options:{
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/10.mp4", //视频源
        type: 'video/mp4', //视频类型
      }},
    {name:"2号监控",options:{
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/13.mp4", //视频源
        type: 'video/mp4', //视频类型
      }},
    {name:"3号监控",options:{
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/12.mp4", //视频源
        type: 'video/mp4', //视频类型
      }},
    {name:"4号监控",options:{
  src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/16.mp4", //视频源
    type: 'video/mp4', //视频类型
}},
    {name:"5号监控",options:{
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/5.mp4", //视频源
        type: 'video/mp4', //视频类型
      },}
  ],
  curVideoIndex:0,
  popShow:false,
  rightData1:[
    {name:'高温',icon:require('@/assets/img/gbzntyj/qixiang1/gw.png')},
    {name:'大风',icon:require('@/assets/img/gbzntyj/qixiang1/df.png')},
    {name:'冰雹',icon:require('@/assets/img/gbzntyj/qixiang1/bb.png')},
    {name:'干旱',icon:require('@/assets/img/gbzntyj/qixiang1/gh.png')},
  ],
  rightDataTxtList:[
    {tit:"未来48小时内可能有大风",time:"14:45"},
    {tit:"未来48小时内可能有大风",time:"14:45"},
    {tit:"未来48小时内可能有大风",time:"14:45"},
    {tit:"未来48小时内可能有大风",time:"14:45"},
    {tit:"未来48小时内可能有大风",time:"14:45"},
    {tit:"未来48小时内可能有大风",time:"14:45"}
  ],
  rightData2:[
    {
      name:"未来48小时",
      data:[
        {
          time: '2024-03-23 11:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 8
        },
        {
          time: '2024-03-23 12:00',
          quality: '优',
          grade: '1级',
          weather: '大雨',
          value: 19
        },
        {
          time: '2024-03-23 13:00',
          quality: '优',
          grade: '1级',
          weather: '多云',
          value: 16
        },
        {
          time: '2024-03-23 14:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 15
        },
        {
          time: '2024-03-23 15:00',
          quality: '优',
          grade: '1级',
          weather: '雨加雪',
          value: 5
        },
        {
          time: '2024-03-23 16:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 5
        },
        {
          time: '2024-03-23 17:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 5
        },
        {
          time: '2024-03-23 18:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 8
        },
        {
          time: '2024-03-23 19:00',
          quality: '优',
          grade: '1级',
          weather: '多云',
          value: 1
        },
        {
          time: '2024-03-23 20:00',
          quality: '优',
          grade: '1级',
          weather: '多云',
          value: 1
        },
        {
          time: '2024-03-23 21:00',
          quality: '优',
          grade: '1级',
          weather: '多云',
          value: 5
        },

      ]
    },
    {
      name:"未来15天",
      data:[
        {
          time: '2024-03-23 9:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 8
        },
        {
          time: '2024-03-24 12:00',
          quality: '优',
          grade: '1级',
          weather: '大雨',
          value: 19
        },
        {
          time: '2024-03-25 9:00',
          quality: '优',
          grade: '1级',
          weather: '多云',
          value: 16
        },
        {
          time: '2024-03-26 9:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 15
        },
        {
          time: '2024-03-27 9:00',
          quality: '优',
          grade: '1级',
          weather: '雨加雪',
          value: 5
        },
        {
          time: '2024-03-28 9:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 5
        },
        {
          time: '2024-03-29 9:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 5
        },
        {
          time: '2024-03-30 9:00',
          quality: '优',
          grade: '1级',
          weather: '大雪',
          value: 8
        },
        {
          time: '2024-03-31 9:00',
          quality: '优',
          grade: '1级',
          weather: '多云',
          value: 1
        },
        {
          time: '2024-04-01 9:00',
          quality: '优',
          grade: '1级',
          weather: '多云',
          value: 1
        },
        {
          time: '2024-04-02 9:00',
          quality: '优',
          grade: '1级',
          weather: '多云',
          value: 5
        },

      ]
    }
  ],
  rightData2Cur:0,
  showDiv:true
});

// 在 onMounted 中初始化地图
onMounted(() => {
  
});
// 弹出视频
function videoClick(index1){
  console.log(index1)
  state.popShow = true
  state.curVideoIndex = index1
}
function popHiddlen(){
  state.popShow = false
}
function clickWeather(index){

  state.showDiv = false; // 点击后先隐藏div
  state.rightData2Cur = index
  setTimeout(() => {
    console.log(state.rightData2Cur )
    state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
  }, 200);
}
function tabClick(index){
  state.rightData1Index = index
}
// 返回上一页
function clickReturn() {
  router.go(-1);
}

onUnmounted(() => {});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});


</script>
<style lang="less" scoped>
.footer{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    font-size: 30px;
    position: fixed;
    bottom: 30px;
    left: 0;
    z-index: 10000;
    font-weight: bold;
    }
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .el-tabs__item {
  width: 102px;
  height: 72px;
  padding: 0;
  // border: 1px solid #1a6266;
  display: flex;
  justify-content: center;

  align-items: self-start;
  position: relative;
  margin: 0 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #fff;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before,
::v-deep .el-tabs__item::after {
  content: " ";
  background: #21fcff;
  width: 2px;
  height: 12px;
  position: absolute;
  top: 12px;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before {
  left: -1px;
}
::v-deep .el-tabs__item::after {
  right: -1px;
}
::v-deep .el-tabs__nav {
  display: flex;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__active-bar {
  width: 100%;
  background-color: #21fcff;
}
::v-deep .is-active {
  color: #a1c81f;
}
::v-deep .el-tabs__nav-prev {
  position: absolute;
  cursor: pointer;
  background: url("../assets/img/plantmoxing/zjt.png") no-repeat top center;
  background-size: 100% 100%;
  width: 18px;
  height: 23px;
  left: 1px;
  top: 20px;

  color: transparent; /* 文字颜色透明 */
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  position: absolute;
  background: url("../assets/img/gbzntyj/qixiang1/bj.jpg") no-repeat top center;
  background-size: 100% 100%;


  .content{
    width: 100%;
    height: calc(100% - 174px);
    display: flex;
    padding: 0 30px;
    box-sizing: border-box;
    .left1, .left2{
      width: 946px;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding:0 0 30px;
    }
    .left1{
      display: flex;
      flex-direction: column;
      .leftBox1{
        height: 40%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 36px;
        .leftBox1_item{
          width: 30%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .leftBox1_item_circle{
            width: 138px;
            height:158px ;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            span{
              display: block;
            }
          }
          .name{
            margin-top: 20px;
            font-size: 30px;
          }
        }
        .leftBox1_item:nth-child(odd){
          .leftBox1_item_circle{
            background: url("../assets/img/gbzntyj/qixiang1/lq.png") no-repeat;
            padding-top: 20px;
          }
        }
        .leftBox1_item:nth-child(even){
          .leftBox1_item_circle{
            background: url("../assets/img/gbzntyj/qixiang1/zq.png") no-repeat;
          }
        }
      }
      .leftBox2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 100px 20px;
        .leftBox2_item{
          display: flex;
          font-size: 30px;
          color: #fff;
          .leftBox2_item_tit{
            width: 160px;
            text-align: right;
          }
          .leftBox2_item_value{
            width: 160px;
            text-align: left;
          }
          .leftBox2_item_bg{
            flex: 1;
            height: 14px;
            background: #0a253c;
            border-radius: 7px;
            margin: 0 20px;
            span{
              display: block;
              height: 14px;
              border-radius: 7px;
              background: #39FEDB;
            }
          }
        }
        .leftBox2_item:nth-child(even){
          .leftBox2_item_bg{
            span{
              background: #6339FE;
            }
          }
        }
      }
    }
    .left2{
      margin-left: 80px;
      display: flex;
      flex-direction: column;
      .left2Box1{
        wiidth:100%;
        height: 45%;
        display: flex;
        flex-direction: column;
      }
      .left2Box2{
        wiidth:100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
      }
    }
    .right{
      width: 1550px;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin-right: 100px;
      .rightBox1{
        width: 100%;
        height: 50%;
        display: flex;
        flex-direction: column;
        .rightBox1_content{
          width: 100%;
          flex: 1;
          display: flex;
          .rightBox1_left{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            width: 380px;
            .rightBox1_left_item{
              margin: 0  20px;
              .rightBox1_left_item_border{
                width: 150px;
                height: 150px;
                border: 1px solid #2C343C;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img{
                  padding: 13px 31.5px;
                  width: 120px;
                  height: 83px;
                  border: 2px solid #C2E8DF;
                }
                h5{
                  font-size: 27px;
                  color: #fff;
                  margin-top: 5px;
                  font-weight: normal;
                }
              }
              h6{
                font-size: 30px;
                color: #fff;
                margin-top: 20px;
              }
            }
          }
          .rightBox1_right{
            flex: 1;
            height: 100%;
            padding: 20px 30px;
            color: #fff;
            font-size: 30px;
            ::v-deep .main_container{height: 500px}
            .scroll_item{
              height: 121px;
              line-height: 121px;
              display: flex;
              justify-content: space-between;
              font-size: 30px;
              padding: 0px 30px;
              span{display: block}
              .tx{
                width: 113px;
                height: 56px;
                line-height: 56px;
                background: rgba(197,118,25,.3);
                color: #FF9023;
                margin: 32.5px 50px 0 0;
              }
              .tit{
                flex: 1;
                text-align: left;
              }
              .time{
                width: 100px;
              }
            }
            .scroll_item:nth-child(even){
              background: rgba(36,54,62,.3);
            }
          }

        }
      }
      .rightBox2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .rightBox2_tit{
          display: flex;
          justify-content: center;
          .rightBox2_tit_item{
            width: 145px;
            height: 82px;
            background: url("../assets/img/gbzntyj/qixiang1/xk.png") no-repeat;
            color: #00E5ED;
            font-size: 22px;
            text-align: center;
            line-height: 82px;
            margin: 0 50px;
          }
          .rightBox2_tit_item_cur{
            color: #F0E003;
          }
        }

      }
    }
    .center{
      flex: 1;
      display: flex;
      flex-direction: column;
      .centerBox1{
        width: 2445px;
        height: 1151px;
        margin: 0 auto;
        position: relative;
        img{
          width: 2445px;
          height:1151px;
        }
        .videoItem{
          position: absolute;
          width: 508px;
          height: 124px;
          //border: 1px solid #f00;
          //font-size: 30px;
          //color: #f00;
        }
        .videoItem:nth-child(2){
          top: 180px;
          left: 443px;
        }
        .videoItem:nth-child(3){
          top: 175px;
          right: 386px;
        }
        .videoItem:nth-child(4){
          top: 577px;
          left: 49px;
        }
        .videoItem:nth-child(5){
          top: 577px;
          right: 3px;
        }
        .videoItem:nth-child(6){
          left: 985px;
          bottom: 185px;
        }
      }
      .centerBox2{
        width: 100%;
        flex: 1;
        padding: 30px 300px;
        // border: 1px solid;
      }
    }
  }
  .bottom{
    position: absolute;
    bottom: 0;
    width: 1911px;
    height: 30px;
    left: 50%;
    margin-left: -955px;
    z-index: 0;
  }
  .title{
    width: 972px;
    height: 130px;
    line-height: 60px;
    background: url("../assets/img/gbzntyj/qixiang1/cgx.png") no-repeat left bottom;
    color: #fff;
    font-size: 40px;
    margin: 20px auto 0;
    span{
      background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: bold;


    }
  }
  .echartsBox{
    width: 100%;
    flex: 1;
  }
}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
.contentLine {
  background: #1aa19e;
  position: absolute;
}
.contentLine1 {
  top: 1px;
  left: 0;
  width: 10%;
  height: 2px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1aa19e);
  animation: animate1 4s linear infinite;
}
.contentLine2 {
  top: -100%;
  right: 0;
  width: 2px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1aa19e);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3 {
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1aa19e);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4 {
  bottom: -100%;
  left: 1px;
  width: 2px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1aa19e);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes animate1 {
  0% {
    left: -50%;
  }

  50%,
  100% {
    left: 100%;
  }
}

@keyframes animate2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}
@keyframes animate3 {
  0% {
    right: -100%;
    height: 3px;
  }

  50%,
  100% {
    height: 2px;
    right: 100%;
  }
}
@keyframes animate4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
